<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block">
          <div class="d-flex">
            <span class="search-wrapper">
              <SearchInput :searchChange="searchChange" />
            </span>
          </div>
          <div class="d-flex">
            <b-button v-b-modal.create-case-list variant="primary" size="lg" class="pl-3 pr-4 d-flex align-items-center">
              <BIconPlus class="mr-2" />
              {{ 'New case list' | i18n }}
            </b-button>
            <b-button
              v-if="CAN_DELETE.includes(auth.role)"
              variant="outline-danger"
              size="lg"
              class="ml-3 pl-4 pr-4 d-flex align-items-center"
              :disabled="!selectedList.length"
              @click="deleteCaseList"
            >
              <img :src="deleteIconUrl" class="mr-2" />
              {{ 'Remove case list' | i18n }}
            </b-button>
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="columns"
          :rows="rows"
          :filter="filter"
          :updateFilter="updateFilter"
          :loadingInstance="loadingInstance"
          :setLoadingInstance="setLoadingInstance"
          :selectedList="selectedList"
          :setSelectedList="setSelectedList"
          class="overflow-auto pr-1"
          tableName="caseListsTable"
        />
        <CreateCaseListModal :generalCaseList="generalCaseList" :getPage="getPage" />
      </div>
    </div>
  </div>
</template>

<script>
import { BIconPlus } from 'bootstrap-vue';

import { ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin } from '../../../../mixins';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import { CAN_DELETE } from '../../../../../../../constants';
import DeleteIcon from '../../../../assets/icons/delete.svg';
import DetailsIcon from '../../../../assets/icons/iconsCode/details.vue';
import api from '../../../api';
import CreateCaseListModal from './create-case-list-modal';

let inputInterval = null;

export default {
  title: 'CaseLists',
  components: { BIconPlus, Table, SearchInput, DetailsIcon, CreateCaseListModal },
  mixins: [ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin],
  data() {
    return {
      deleteIconUrl: DeleteIcon,
      selectedList: [],
      loadingInstance: null,
      CAN_DELETE,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        searchQuery: '',
      },
      columns: [
        {
          field: 'name',
          title: this.$translate('Case list name'),
          key: 'name',
          align: 'left',
          sortBy: 'desc',
          width: 250,
        },
        {
          field: 'caseNameList',
          title: this.$translate('Case name'),
          key: 'caseNameList',
          align: 'left',
        },
        {
          field: 'actions',
          key: 'actions',
          title: '',
          width: 50,
          renderBodyCell: ({ row }, h) => {
            return (
              <b-button variant="primary" size="sm" class="p-2 size-12" on-click={() => this.goToEditCaseList(row.id)}>
                <DetailsIcon />
              </b-button>
            );
          },
        },
      ],
      rows: [],
      generalCaseList: [],
    };
  },
  async created() {
    if (this.CAN_DELETE.includes(this.auth.role)) {
      this.columns = [
        {
          field: 'check',
          key: 'check',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        ...this.columns,
      ];
    }

    const generalCaseList = await this.reportsService.getCasesPage({});
    this.generalCaseList = generalCaseList;
  },
  methods: {
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    goToEditCaseList(id) {
      this.$router.push({ name: 'case-list-details', params: { id } });
    },
    async deleteCaseList() {
      try {
        await this.deleteSelectedRows(
          { message: this.$translate('case_delete_message') },
          async () => {
            const ids = this.selectedList.map((r) => r.id);
            await api.caseLists.delete(ids);
            this.selectedList = [];
            this.getPage();
          }
        );
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        const response = await api.caseLists.get(ctx);
        response.data = response.data.map((item) => ({
          ...item,
          caseNameList: item.casesList.map(({ title }) => title).join(', '),
        }));
        this.filter.totalCount = response.totalCount;
        this.rows = response.data;
        this.stopLoading();
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

.search-wrapper {
  margin-right: 10px;
  display: flex;
  align-items: center;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .size-12 {
  font-size: 12px;
  line-height: 12px;
}
</style>
